import { AccessorKeyColumnDef, flexRender, getCoreRowModel, useReactTable } from '@tanstack/react-table';
import { Card, Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { Product } from '../../types';

interface TableListProps {
  products: Product[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  columns: AccessorKeyColumnDef<Product, any>[];
}

const TableList = ({ products, columns }: TableListProps) => {
  const tableInstance = useReactTable({ data: products!, columns, getCoreRowModel: getCoreRowModel() });

  return (
    <Card>
      <Table size="sm" className="card-table table-nowrap" hover responsive>
        <thead>
          {tableInstance.getHeaderGroups().map(headerGroup => {
            return (
              <tr key={headerGroup.id}>
                {headerGroup.headers.map(header => {
                  return (
                    <th colSpan={header.colSpan} key={header.id}>
                      {header.isPlaceholder ? null : flexRender(header.column.columnDef.header, header.getContext())}
                    </th>
                  );
                })}
              </tr>
            );
          })}
        </thead>
        <tbody>
          {tableInstance.getRowModel().rows.map(row => {
            return (
              <tr key={row.id}>
                {row.getVisibleCells().map(cell => {
                  return (
                    <td key={cell.id}>
                      <Link to={`./${row.original._id}`}>
                        {flexRender(cell.column.columnDef.cell, cell.getContext())}
                      </Link>
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </Table>
    </Card>
  );
};

export default TableList;
